var React = require('react');

function ArrowInRightInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#000"},React.createElement("g",null,React.createElement("path",{"d":"M364.486 24.46v-1.145c-.454 0-.867-.023-1.218-.044-.72-.081-1.751-.477-2.638-1.332l-.764-.75L362.032 19 369 26.002 362.032 33l-2.166-2.187.764-.748c.433-.438.887-.75 1.361-.938.968-.42 1.607-.438 2.495-.438v-1.147H353V24.46h11.486z","transform":"translate(-880 -611) translate(527 592)"})))));
}

ArrowInRightInline.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = ArrowInRightInline;

ArrowInRightInline.default = ArrowInRightInline;
